// extracted by mini-css-extract-plugin
var _1 = "ExtensionErrorBoundary-module__animateUploadProgressBarWidth--CV11e";
var _2 = "ExtensionErrorBoundary-module__animatedBackground--eFq0S";
var _3 = "ExtensionErrorBoundary-module__container--tpPEm";
var _4 = "ExtensionErrorBoundary-module__content--BFSlQ";
var _5 = "ExtensionErrorBoundary-module__logo--k3oLe";
var _6 = "ExtensionErrorBoundary-module__message--oZp8U";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "logo", _6 as "message" }
